import type { Nullable } from '@ats/interfaces';

export class SessionStorageHandler {
  public bulkUpdateWithArray(items: { key: string; value: string }[]): void {
    items.forEach((_, idx) => {
      const { key, value } = items[idx];
      sessionStorage.setItem(key, value);
    });
  }

  public bulkUpdateWithObject(item: Record<string, any>): void {
    for (const [key, value] of Object.entries(item)) {
      sessionStorage.setItem(key, value);
    }
  }

  public setItem(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  public getItem(key: string): Nullable<string> {
    return sessionStorage.getItem(key);
  }

  public bulkReadWithArray<T>(keySet: string[]) {
    return Object.fromEntries(
      keySet.map((key) => [key, this.getItem(key) ?? '']),
    ) as Record<string, Nullable<T>>;
  }
}
